module.exports = function(app) {
    app.directive('mnloaValidation', ["$window", "$compile",function($window, $compile) {

        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.mnloaValidation = function(modelValue, viewValue) {
                    var bRetval = true ;
                      if(modelValue === 'false' || modelValue === false){
                          bRetval= false;
                      }
                    return bRetval ;
                };
            }
        };
    }]);
};


